import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, FAILED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { REQUEST_WEBSITE_FLOWS, RECEIVE_WEBSITE_FLOWS, FAIL_GETTING_WEBSITE_FLOWS } from 'ui-forms-editor-automation-lib/actions/fetchWebsiteFlows';
import { SUCCESS_REMOVING_WEBSITE_FLOWS, SUCCESS_SCHEDULING_REMOVING_WEBSITE_FLOWS, FAIL_REMOVING_WEBSITE_FLOWS } from 'ui-forms-editor-automation-lib/actions/removeWebsiteFlows';
import { RESET_WEBSITE_FLOWS } from 'ui-forms-editor-automation-lib/actions/resetWebsiteFlows';
export const INITIAL_STATE = {
  websiteFlows: [],
  error: {},
  fetchRequestState: NOT_REQUESTED,
  removeRequestState: NOT_REQUESTED,
  guid: null
};
export default handleActions({
  [REQUEST_WEBSITE_FLOWS]: (_, {
    payload
  }) => ({
    websiteFlows: [],
    fetchRequestState: REQUESTED,
    removeRequestState: NOT_REQUESTED,
    error: {},
    guid: payload
  }),
  [RECEIVE_WEBSITE_FLOWS]: (state, {
    payload
  }) => Object.assign({}, state, {
    websiteFlows: payload,
    fetchRequestState: SUCCEEDED,
    removeRequestState: NOT_REQUESTED,
    error: {}
  }),
  [FAIL_GETTING_WEBSITE_FLOWS]: (state, {
    payload
  }) => Object.assign({}, state, {
    websiteFlows: [],
    fetchRequestState: FAILED,
    removeRequestState: NOT_REQUESTED,
    error: payload
  }),
  [SUCCESS_SCHEDULING_REMOVING_WEBSITE_FLOWS]: state => Object.assign({}, state, {
    removeRequestState: SUCCEEDED
  }),
  [SUCCESS_REMOVING_WEBSITE_FLOWS]: state => Object.assign({}, state, {
    websiteFlows: [],
    removeRequestState: SUCCEEDED
  }),
  [FAIL_REMOVING_WEBSITE_FLOWS]: (state, {
    payload
  }) => Object.assign({}, state, {
    removeRequestState: FAILED,
    error: payload
  }),
  [RESET_WEBSITE_FLOWS]: state => Object.assign({}, state, {
    removeRequestState: NOT_REQUESTED
  })
}, INITIAL_STATE);